<template>
  <pop-box
    ref="myPopbox"
    class="upload-popbox"
    :hasNotButton="true"
    :title="title"
    @closeDialog="$emit('close')"
    :width="750"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="电话号码" prop="phoneNumber">
        <el-input v-model="formData.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="证件号" prop="identityCard">
        <el-input v-model="formData.identityCard"></el-input>
      </el-form-item>
      <el-form-item label="学历" prop="education">
        <el-select clearable v-model="formData.education" placeholder="请选择" @change="employeeChange">
          <el-option
            v-for="(item,index) in educationList"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工种" prop="post">
        <el-select clearable v-model="formData.post" placeholder="请选择" @change="employeeChange">
          <el-option
            v-for="(item,index) in postList"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="住所" prop="residencePlace">
        <el-input v-model="formData.residencePlace"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onSave">保存</el-button>
      <el-button class="btnx-normal btn-gray" @click="onClose">关闭</el-button>
    </div>
  </pop-box>
</template>
<script>
import { getAction , putAction } from "@/service/http/api";
import editMixin from "@/mixin/editModal";
import formRules from "@/service/formRules"
export default {
  name: "Edit",
  props: ["rowId", "title", "mode"],
  mixins: [editMixin],
  data() {
    return {
      educationList:['大专','本科','硕士','博士'],
      postList:['普工','高工'],
      formData: {
        name: null,
        phoneNumber: null,
        identityCard: null,
        education: null,
        post: null,
        residencePlace: null,
        userId:null,
      },
      rules:{
        name:[ { required: true, message: '请输入姓名', trigger: 'blur' }],
        phoneNumber:[formRules.tel],
        pwd:[formRules.pwd],
        identityCard:[formRules.shenfen],
      },
      url: {
        add: "/employee/employeeInfo/add",
        query: "/employee/employeeInfo/queryById",
        edit: "/employee/employeeInfo/edit"
      },
    };
  }
};
</script>

<style lang="scss" scoped>
.img-item {
  margin: 20px 40px;
  float: left;
  position: relative;
  width: 300px;
  p {
    line-height: 30px;
    color: #0d74fe;
  }
  .left,
  .right {
    position: absolute;
    top: 0;
    width: 30px;
    height: 300px;
    background: #ffffff;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
}
.img-item img {
  width: 240px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/employee_management/edit.vue